import { render, staticRenderFns } from "./stop-case-import.vue?vue&type=template&id=4ff4e0d7&scoped=true"
import script from "./stop-case-import.vue?vue&type=script&lang=ts"
export * from "./stop-case-import.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff4e0d7",
  null
  
)

export default component.exports